import { env } from 'lib/constants/env';

export const getBaseUrl = () => env.NEXT_PUBLIC_SITE_URL.replace(/\/+$/, '');

export const getPageUrl = (pagePath: string) => {
  // strip query params from page path
  const url = new URL(`${getBaseUrl()}${pagePath}`);
  return `${url.origin}${url.pathname}`;
};
